function loadScript(url) {
  document.addEventListener('DOMContentLoaded', function (event) {
    let script = document.createElement('script')
    script.src = url
    document.head.appendChild(script)
  })
}
function loadStyleSheet(url) {
  document.addEventListener('DOMContentLoaded', function (event) {
    let styleSheet = document.createElement('link')
    styleSheet.rel = 'stylesheet'
    styleSheet.href = url
    document.head.appendChild(styleSheet)
  })
}
const modules = {

  fancybox: {
    default: '.gallery-with-fancybox-wrapper',
    init: function () {
      loadStyleSheet('https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.css')
      loadScript('https://cdn.jsdelivr.net/npm/@fancyapps/ui@4.0/dist/fancybox.umd.js')
    },
  }
}

function initModules(obj, scope = document) {
  for (let key in obj) {
    let query = obj[key].default || key
    if (scope.querySelector(query)) {
      obj[key].init(query)
    }
  }
}

initModules(modules)
